import * as React from "react";
import { cn } from "../../lib/utils";
import { Eye, EyeOff } from "lucide-react";

const Input = React.forwardRef(
  (
    {
      className,
      placeholder,
      type,
      disabled,
      preContentIcon: PreContentIcon,
      ...props
    },
    ref
  ) => {
    return (
      <div className="relative w-full flex items-center">
        {PreContentIcon && (
          <div className="absolute left-3 my-auto z-10 text-gray-500">
            <span className=" text-sm flex items-center ">
              {" "}
              {PreContentIcon}
            </span>
          </div>
        )}
        <input
          type={type}
          readOnly={disabled}
          min={1}
          className={cn(
            `flex h-10 w-full rounded-md border border-input bg-background p-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:cursor-not-allowed
            read-only:bg-greyShade disabled:opacity-50 focus:outline-none focus:ring-0`,
            PreContentIcon ? "!pl-10" : "", // Add left padding if icon is present
            className
          )}
          placeholder={placeholder}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";

const PasswordInput = React.forwardRef(
  (
    { className, placeholder, value, onChange, error, disabled, ...props },
    ref
  ) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="relative w-full">
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            className={cn(
              "flex h-10 w-full rounded-md border border-input bg-background p-3 pr-10 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none focus:ring-0",
              error ? "border-red-500" : "",
              className
            )}
            min={1}
            value={value}
            onChange={onChange}
            readOnly={disabled}
            ref={ref}
            {...props}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            disabled={disabled}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none disabled:opacity-50"
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5" />
            ) : (
              <Eye className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export { PasswordInput, Input };
